import { circle, circle1, pstructure, star1, star2 } from "../../assets/images/icons";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/Navbar";
import Topbar from "../../components/Topbar/Topbar";
import "./notfound.css";
import { useTranslation } from 'react-i18next'; // Import the translation hook

export default function Notfound() {
  const { t } = useTranslation(); // Initialize the translation hook

  return (
    <div className="Page_notfound">
      <Topbar />
      <Navbar />
      <div className="main">
        <div className="container">
          <p className="big_404">{t("notfound.title")}</p>
          <p className="blue_text">{t("notfound.sorry_message")}</p>
          <p className="white_text">{t("notfound.error_message")}</p>
        </div>
        <img className="s1" src={star1} alt="star1" />
        <img className="s2" src={star2} alt="star2" />
        <img className="c1" src={circle} alt="circle" />
        <img className="c2" src={circle1} alt="circle1" />
        <img className="pstructure" src={pstructure} alt="pstructure" />
      </div>
      <Footer />
    </div>
  );
}